import React, { createContext, useEffect, useState } from "react";
import { polizaDefault } from "../data/data";
import useQuestion from "../hooks/useQuestion";
import { PLAN_ID } from "../utils/constanst";

export const DataContext = createContext();

export const DataProvier = ({loading, children }) =>{
    
    const [poliza, setPoliza] = useState({...polizaDefault});
    const { getQuestions, questions } = useQuestion(PLAN_ID);
    

    const changeHandler = event => {
        setPoliza({...poliza, [event.target.name] : event.target.value});
    }    

    useEffect(() => {

        if(!loading)   
            getQuestions();
       
    }, [ loading ]);

    useEffect(() => {

        if(questions)
            setPoliza({...poliza, questions: questions});
            
    }, [questions]);

    return (
        <DataContext.Provider value={{ poliza, setPoliza, changeHandler }}>
            {children}
        </DataContext.Provider>
    );

}